import React from 'react';
import styled from 'styled-components';
import spinner from './spinner.gif';

const Container = styled.div`
  position: relative;
  
  & > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Spinner = () => (
  <Container>
    <img id="icon-loading" src={spinner} width={50} height={50} alt="loading" />
  </Container>
);

export default Spinner;
